module.exports = __webpack_public_path__ + "static/tripbooker-1e2da18c8a6feb4586de8a59037ecc39.png";